import styled from 'styled-components';
import { absFull } from 'helpers/styles.js';
import dropdownArrow from 'images/icons/dropdownArrow.svg';

export const InputLabel = styled.div`
  font-weight: bold;
  font-size: 10px;
  line-height: 14px;
  padding: 10px 0;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: white;
`;

export const DropdownContainer = styled.div`
position: relative;
border: 1px solid #6CA5D6;
box-sizing: border-box;
border-radius: 2px;
padding: 11px 17px;
cursor: pointer;

&:hover {
  background: rgba(255,255,255,.1);  
}
`;

export const DropdownArrow = styled.div`
${absFull('15px', '18px', 'auto', 'auto')};
background: url('${dropdownArrow}') center center no-repeat;
background-size: 100%;
height: 10px;
width: 12px;
`;

export const DropdownOptions = styled.div`
${absFull('5px', 'auto', 'auto', 'auto')};
width: 100%;
background: #2B4F70;
border-radius: 5px;
z-index: 2;
`;

export const DropdownScrollContainer = styled.div`
height: 120px;
`;

export const StyledDropdownOption = styled.div`
padding: 10px 12px;

&:hover {
  cursor: pointer;
  background: rgba(255,255,255,.1);
}
`;

export const Tick = styled.div`
display: inline-block;
height: 6px;
width: 6px;
vertical-align: middle;
border-radius: 100%;
background-color: ${({ selected, theme }) => selected ? theme.colors.palette[7] : theme.colors.palette[4]};
`;
